import React from "react";
import { Container, Paper, Typography, List, ListItem, ListItemText } from "@mui/material";

export default function ServiceAgreementView() {
  return (
    <Container maxWidth="md" sx={{ py: { xs: 3, sm: 6 } }}>
      <Paper elevation={0} sx={{ p: { xs: 2, sm: 4 } }}>
        <Typography
          variant="h4"
          color="text.secondary"
          align="center"
          fontWeight="bold"
          gutterBottom
        >
          时空笔记用户服务协议
        </Typography>

        <Typography variant="body2" color="text.secondary" paragraph>
          <strong>生效日期：2025年11月24日</strong>
          <br />
          <strong>开发者：于静云</strong>
        </Typography>

        <Typography paragraph>
          欢迎您使用“时空笔记”（以下简称“本应用”或“我们”）。在您下载、安装、访问或使用本应用前，请务必仔细阅读并充分理解本《用户服务协议》（以下简称“本协议”）的全部内容。您的使用行为将被视为对本协议的完全接受。
        </Typography>

        <Typography
          variant="h6"
          color="text.secondary"
          fontWeight="medium"
          sx={{ mt: 3 }}
          gutterBottom
        >
          一、服务内容
        </Typography>
        <Typography paragraph>本应用旨在为用户提供以下功能服务：</Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="1. 记录用户的移动轨迹" />
          </ListItem>
          <ListItem>
            <ListItemText primary="2. 在地图上动态重现历史轨迹" />
          </ListItem>
          <ListItem>
            <ListItemText primary="3. 支持拍摄照片与录制视频" />
          </ListItem>
          <ListItem>
            <ListItemText primary="4. 根据照片/视频中嵌入的地理位置信息，在地图上进行可视化标注" />
          </ListItem>
        </List>
        <Typography paragraph>
          所有数据默认仅存储于设备本地，支持云端同步服务（云端数据位置：华为云空间）。
        </Typography>

        <Typography
          variant="h6"
          color="text.secondary"
          fontWeight="medium"
          sx={{ mt: 3 }}
          gutterBottom
        >
          二、用户承诺与义务
        </Typography>
        <Typography paragraph>
          仅将本应用用于合法、正当的个人用途，不得用于非法测绘、侵犯他人隐私、商业监控等违法活动
        </Typography>

        <Typography paragraph>
          不得利用本应用采集国家秘密、军事设施、敏感区域等受法律保护的地理信息
        </Typography>

        <Typography paragraph>不得上传、传播含有违法、色情、暴力、侵权等内容的媒体文件</Typography>

        <Typography paragraph>
          自行承担因开启定位、相机、存储等权限所引发的设备电量消耗、存储占用等后果
        </Typography>

        <Typography paragraph>
          妥善保管设备，防止他人未经授权使用本应用访问您的轨迹与媒体数据
        </Typography>

        <Typography
          variant="h6"
          color="text.secondary"
          fontWeight="medium"
          sx={{ mt: 3 }}
          gutterBottom
        >
          三、知识产权
        </Typography>
        <Typography paragraph>
          本应用的所有源代码、界面设计、图标、文档及相关技术成果，其知识产权归开发者所有。未经书面许可，您不得对本应用进行反向工程、反编译、修改、出租、出售或用于开发衍生产品。
        </Typography>
        <Typography paragraph>
          您通过本应用创建的轨迹、照片、视频等数据，其所有权和著作权归您本人所有，但您授权本应用在设备本地范围内进行必要读取与展示。
        </Typography>

        <Typography
          variant="h6"
          color="text.secondary"
          fontWeight="medium"
          sx={{ mt: 3 }}
          gutterBottom
        >
          四、免责声明
        </Typography>
        <Typography paragraph>
          本应用依赖设备卫星定位模块及系统定位服务，定位精度受环境、天气、设备性能等因素影响，开发者不对轨迹准确性、完整性作任何保证
        </Typography>

        <Typography paragraph>
          因设备故障、操作系统限制、权限拒绝或用户操作失误导致的数据丢失、轨迹中断等问题，开发者不承担责任
        </Typography>

        <Typography paragraph>
          本应用不收集、不上传、不分析您的个人数据（详见《隐私声明》），因此无法提供数据找回、远程恢复等服务
        </Typography>

        <Typography paragraph>
          如因不可抗力（如地震、断电、网络攻击、政策调整等）导致服务中断，开发者不承担赔偿责任
        </Typography>

        <Typography
          variant="h6"
          color="text.secondary"
          fontWeight="medium"
          sx={{ mt: 3 }}
          gutterBottom
        >
          五、协议变更与终止
        </Typography>
        <Typography paragraph>
          开发者有权根据法律法规变化或产品优化需要，适时修订本协议。更新后将通过应用内公告或弹窗形式通知您。若您继续使用本应用，即视为接受修改后的协议。
        </Typography>
        <Typography paragraph>
          您可随时卸载本应用以终止服务。开发者亦有权在发现您违反本协议或从事违法活动时，暂停或终止您对本应用的使用权限。
        </Typography>

        <Typography
          variant="h6"
          color="text.secondary"
          fontWeight="medium"
          sx={{ mt: 3 }}
          gutterBottom
        >
          六、其他
        </Typography>
        <Typography paragraph>
          本协议的订立、生效、履行、解释及因本协议引起的或与本协议有关的一切争议的解决，均适用中华人民共和国大陆地区法律（不含港澳台地区）。若本协议任何条款被有管辖权的法院认定为违反中华人民共和国大陆地区法律而无效或不可执行，则该条款应在法律允许的最大范围内予以限缩解释或重新解析，以尽可能实现其原始意图；本协议其余条款的效力不受影响，继续完全有效。
        </Typography>

        <Typography paragraph>
          本协议的履行地为开发者所在地。如您与开发者就本协议内容或其履行发生任何争议，双方应首先通过友好协商解决；协商不成的，您同意将争议提交至开发者所在地有管辖权的人民法院诉讼解决。
        </Typography>

        <Typography paragraph>
          开发者有权根据国家法律法规、监管政策、技术发展或产品运营需要，不时对本协议进行修订。更新后的协议将通过应用内公告、弹窗或其他合理方式予以公布。前述修改内容一经公布，即视为已通知您。修改后的协议构成本协议不可分割的组成部分，您应予遵守。如您不同意修改后的内容，请立即停止使用“时空笔记”软件及相关服务；您继续使用本应用的行为，将被视为已充分理解并接受修改后的协议。
        </Typography>

        <Typography paragraph>
          本协议所设标题仅为阅读便利之目的，不影响对协议条款含义或解释的确定。
        </Typography>

        <Typography paragraph>
          您与开发者均为独立的法律主体。本协议的签署与履行，不构成开发者对您作出任何形式的明示或暗示的担保、保证或承诺，亦不构成双方之间存在代理、合伙、合资、雇佣或任何其他形式的法律关系。
        </Typography>

        <Typography paragraph>
          本协议的版权为我们所有，在法律允许的范围内，我们保留一切解释和修改的权利。
        </Typography>
        <Typography
          variant="h6"
          color="text.secondary"
          fontWeight="medium"
          sx={{ mt: 3 }}
          gutterBottom
        >
          七、联系我们
        </Typography>
        <Typography paragraph>
          <strong>邮箱</strong>：2954060395@qq.com
        </Typography>
      </Paper>
    </Container>
  );
}
